// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__264I4","location":"Header_location__C4z9J"};